import App from "./App";
import ProtectedRoute from "./components/ProtectedRoute";
import AccessDenied from "./pages/AccessDenied";
import Dashboard from "./pages/Dashboard";
import ErrorPage from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPage";
import SharedView from "./pages/SharedView";

const routes = [
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            // {
            //     path: '/admin',
            //     element:
            //         <ProtectedRoute requiredPermission="can_view_admin_page">
            //             <AdminPage />
            //         </ProtectedRoute>
            // },
            {
                path: '/',
                element: <Dashboard/>
            },
            {
                path: '/error',
                element: <ErrorPage />
            },
            {
                path: '/access-denied',
                element: <AccessDenied />
            },
        ]
    },
    {
        path: '/login',
        element: <LoginPage />
    },
    {
        path: '/shared/:token',
        element: <SharedView />
    }
];

export default routes;